import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../lib/api";
import { ArrowLeft, Bell, Settings } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import NotificationSettings from "../../components/NotificationSettings";

export default function Notifications() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [settingsOpen, setSettingsOpen] = useState(false);
  useEffect(() => {
    api.get("/notifications").then(({ data }) => setItems(data)).catch(() => {});
    api.post("/notifications/read-all").catch(() => {});
  }, []);
  return (
    <div className="min-h-screen bg-[#0A0A0C] text-white" data-testid="notifications-page">
      <div className="max-w-2xl mx-auto px-4 py-6">
        <button onClick={() => navigate("/esplora")} className="flex items-center gap-2 text-zinc-400 hover:text-white mb-4 text-sm" data-testid="notif-back"><ArrowLeft className="h-4 w-4" /> Mappa</button>
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3"><div className="h-12 w-12 rounded-2xl bg-[#00E676]/15 border border-[#00E676]/40 flex items-center justify-center"><Bell className="h-6 w-6 text-[#00E676]" /></div><h1 className="text-2xl font-display font-bold">Notifiche</h1></div>
          <button data-testid="notif-settings-btn" onClick={() => setSettingsOpen(true)} className="h-10 w-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center hover:bg-white/10 transition-colors" aria-label="Impostazioni notifiche">
            <Settings className="h-5 w-5 text-zinc-300" />
          </button>
        </div>
        <div className="space-y-2">
          {items.map((n) => (
            <div key={n.id} data-testid={`notif-${n.id}`} className="bg-[#1C1C1F] border border-white/10 rounded-lg p-4">
              {n.title && <div className="text-sm font-semibold text-[#00E676] mb-0.5">{n.title}</div>}
              <div className="text-sm">{n.message}</div>
              <div className="text-[11px] text-zinc-500 mt-1">{n.created_at ? new Date(n.created_at).toLocaleString("it-IT") : ""}</div>
            </div>
          ))}
          {items.length === 0 && <div className="text-zinc-500 py-10 text-center">Nessuna notifica.</div>}
        </div>
      </div>

      <Dialog open={settingsOpen} onOpenChange={setSettingsOpen}>
        <DialogContent className="bg-[#151517] border-white/10 text-white max-w-lg max-h-[85vh] overflow-y-auto" data-testid="notif-settings-dialog">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2"><Settings className="h-5 w-5 text-[#00E676]" /> Impostazioni notifiche</DialogTitle>
          </DialogHeader>
          <NotificationSettings />
        </DialogContent>
      </Dialog>
    </div>
  );
}
